import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/wage-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IWage } from 'src/types/wage';
import WageActionsColumn from './WageActionsColumn';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import { CellProps } from 'react-table';
import { IInvoice } from '../../../../../../../types/invoice';
import { Link, useRouteMatch } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { IPayment } from '../../../../../../../types/payment';
import dateFilter from '../../../../../../../components/react-table/filters/date-filter';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IWage>;
    getData: (params: QueryParams) => void;
    providers: SelectObject[];
}

const getColumns = (dataProd: SelectObject[]): Column<IWage>[] => [
    {
        Header: '#',
        accessor: 'id',
        Filter: textFilter<IWage>(),
    },
    {
        Header: 'Provider Full Name',
        accessor: 'provider.id',
        disableSortBy: true,
        Filter: dropdownFilter<IWage>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoice>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
    },
    {
        Header: 'Fixed salary',
        accessor: 'amount',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IWage>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => (original.amount ? `$${numberWithCommas(original.amount)}` : '$0'),
    },
    {
        Header: 'Period Start',
        accessor: 'periodStart[after]',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IWage>) => {
            const valueOrderType = original.periodStart;

            return <div>{`${changeToZeroMoment(valueOrderType, 'MMM D, YYYY')}`}</div>;
        },
        Filter: dateFilter<IWage>(),
    },

    {
        Header: 'Period End',
        accessor: 'periodEnd[before]',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IWage>) => {
            const valueOrderType = original.periodEnd;

            return <div>{`${changeToZeroMoment(valueOrderType, 'MMM D, YYYY')}`}</div>;
        },
        Filter: dateFilter<IWage>(),
    },
    {
        Header: 'Actions',
        accessor: 'createdAt',
        Cell: WageActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const WagesGrid: React.FunctionComponent<Props> = ({ data, getData, providers }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }
    const match: any = useRouteMatch();
    // const filtersInit: any = [];
    const filtersInit: any = [];

    if (Object.values(match.params).length && match.params.param) {
        filtersInit.push({ id: 'provider.id', value: +match.params.param });
    }

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IWage> columns={columns} filtersInit={filtersInit} data={data} getData={getData} />
        </div>
    );
};

export default WagesGrid;
